import React from 'react';
import styles from './styles.module.css';
function Tooltip({children, content}) {
  return (
    <div className={styles.tooltipContainer}>
      {children}
        <span className={styles.tooltipTextToggleSwitch}>
          {content}
        </span>
    </div>
  );
}
export default Tooltip
